import {ArchiveIcon, ChevronRightIcon} from "lucide-react";
import {Link} from "react-router";
import {Backup} from "@/backup/Backup.ts";
import {BackupStateBadge} from "@/backup/BackupStateBadge.tsx";
import {Card, CardHeader, CardTitle} from "@/components/ui/card.tsx";
import {cn} from "@/lib/utils.ts";
import {formatBackupDisplayName} from "@/backup/BackupPresentation.ts";

export function BackupList({backups, selectedId}: {backups: Backup[]; selectedId?: string}) {
    return <Card className="gap-0 overflow-hidden py-0">
        <CardHeader className="flex min-h-14 flex-row items-center justify-between border-b px-4 py-3">
            <CardTitle className="text-sm">Verfügbare Backups</CardTitle>
            <span className="text-xs text-muted-foreground">{backups.length} Sicherungen</span>
        </CardHeader>
        <nav className="max-h-[calc(100vh-15rem)] overflow-y-auto p-2" aria-label="Verfügbare Backups">
            {backups.length === 0 && <div className="p-6 text-center text-sm text-muted-foreground">
                Noch keine Backups vorhanden.
            </div>}
            {backups.map(backup => {
                const selected = backup.id === selectedId;
                return <Link key={backup.id} to={`/admin/backups/${backup.id}`}
                             aria-current={selected ? "page" : undefined}
                             className={cn(
                                 "group mb-1 grid grid-cols-[2rem_minmax(0,1fr)_auto] items-center gap-3 rounded-lg border border-transparent px-3 py-2.5 transition-colors hover:bg-accent/60 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                                 selected && "border-primary/30 bg-primary/10 hover:bg-primary/10"
                             )}>
                    <span className={cn(
                        "flex size-8 items-center justify-center rounded-md bg-muted text-muted-foreground",
                        selected && "bg-primary/15 text-primary"
                    )}>
                        <ArchiveIcon className="size-4"/>
                    </span>
                    <span className="min-w-0">
                        <span className="block truncate text-sm font-medium">
                            {formatBackupDisplayName(backup)}
                        </span>
                        <span className="mt-0.5 block truncate text-xs text-muted-foreground"
                              title={backup.filename}>
                            {backup.filename}
                        </span>
                        <BackupStateBadge state={backup.state} className="mt-1.5"/>
                    </span>
                    <ChevronRightIcon className="size-4 text-muted-foreground transition-transform group-hover:translate-x-0.5"/>
                </Link>;
            })}
        </nav>
    </Card>;
}
